import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { BonDto, BonPreparationIndicateursDto, FluxEtapeDto, FluxStatut, MouvementSens, ObjectType, PreparationsLexiClient, StatutPreparationTermine } from '@lexi-clients/lexi';
import { catchError, lastValueFrom, of } from 'rxjs';

@Component({
    selector: 'app-bon-detail-entete',
    templateUrl: './bon-detail-entete.component.html',
    styleUrls: ['./bon-detail-entete.component.scss'],
    standalone: false
})
export class BonDetailEnteteComponent implements OnChanges {
  @Input() isCreation: boolean;
  @Input() canEditDateSouhaite: boolean;
  @Input() bon: BonDto;
  @Input() mouvementTypeIntitule: string;
  @Input() readonly fluxStatutDataSource: Array<{ id: FluxStatut, intitule: string }>
  @Input() isModificationEnCours: boolean;

  @Output() backButtonClicked = new EventEmitter<MouseEvent>();

  fluxEtapeDataSource: FluxEtapeDto[];
  FluxStatut = FluxStatut;
  ObjectType = ObjectType;
  StatutPreparationTermine = StatutPreparationTermine;
  MouvementSens = MouvementSens;

  // Indicateurs de préparation
  indicateurs: BonPreparationIndicateursDto | null = null;

  constructor(
    private readonly preparationsLexiClient: PreparationsLexiClient
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bon'] && this.bon?.id && this.bon?.sens !== MouvementSens.inventaire) {
      this.chargerIndicateursPreparation();
    }
  }

  get bonStatut(): string {
    if (!this.bon?.fluxStatut) return "";
    return this.fluxStatutDataSource.find(x => x.id == this.bon.fluxStatut)?.intitule;
  }

  onBackButtonClicked(event: MouseEvent): void {
    this.backButtonClicked.emit(event);
  }

  private async chargerIndicateursPreparation() {
    // Chargement non bloquant des indicateurs
    try {
      const result = await lastValueFrom(this.preparationsLexiClient.getIndicateursPreparation(this.bon.id));
      this.indicateurs = result;
    } catch {
      this.indicateurs = null;
    }
  }

}
